import AllTasksWrapper from './AllTasksWrapper';

export default AllTasksWrapper;
